import { message } from "antd";
import { Get, Post } from "../../helpers/apicalls/apicalls";
import * as actionTypes from "./PackagesTypes";

///////////////// PLANS ACTIONS /////////////////
export const getPlans = (values) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.PLAN_LOADING });
    Post("/agents/user/admin/get-plan-types", values)
      .then((res) => {
        if (res?.status) {
          dispatch({
            type: actionTypes.PLAN_SUCCESS,
            payload: res?.data,
          });
        } else {
          dispatch({ type: actionTypes.PLAN_FALED });
        }
      })
      .catch((err) => {
        dispatch({ type: actionTypes.PLAN_FALED });
      });
  };
};

export const createPlan = (data, afterSuccess) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.CREATE_PLAN_LOADING });
    Post("/agents/user/admin/create-plan-types", data)
      .then((res) => {
        if (res?.status) {
          dispatch({ type: actionTypes.CREATE_PLAN_SUCCESS });
          afterSuccess();
        } else {
          dispatch({
            type: actionTypes.CREATE_PLAN_FALED,
          });
          message.error(res?.message, 10);
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.CREATE_PLAN_FALED,
        });
      });
  };
};

export const updatePlan = (data, afterSuccess) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.UPDATE_PLAN_LOADING });
    Post("/agents/user/admin/update-plan-types", data)
      .then((res) => {
        if (res?.status) {
          dispatch({ type: actionTypes.UPDATE_PLAN_SUCCESS });
          afterSuccess();
        } else {
          dispatch({
            type: actionTypes.UPDATE_PLAN_FALED,
          });
          message.error(res?.message, 10);
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.UPDATE_PLAN_FALED,
        });
      });
  };
};
///////////////// PLANS ACTIONS END /////////////////

///////////////// PACKAGES ACTIONS /////////////////
export const getPackages = (data) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.IS_LOADING });
    Post("/agents/user/admin/get-packages", data)
      .then((res) => {
        if (res?.status) {
          dispatch({
            type: actionTypes.PACKAGE_DATA_SUCCESS,
            payload: res?.data,
          });
        } else {
          dispatch({ type: actionTypes.PACKAGE_DATA_FALED });
        }
      })
      .catch((err) => {
        dispatch({ type: actionTypes.PACKAGE_DATA_FALED });
      });
  };
};

export const createPackage = (data, afterSuccess) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.IS_PACKAGE_CREATE_LOADING });
    Post("/agents/user/admin/create-package", data)
      .then((res) => {
        if (res?.status) {
          dispatch({ type: actionTypes.PACKAGE_CREATE_SUCCESS });
          afterSuccess();
        } else {
          dispatch({
            type: actionTypes.PACKAGE_CREATE_FALED,
          });
          message.error(res?.message, 10);
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.PACKAGE_CREATE_FALED,
        });
      });
  };
};

export const updatePackage = (data, afterSuccess) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.IS_PACKAGE_UPDATE_LOADING });
    Post("/agents/user/admin/update-package", data)
      .then((res) => {
        if (res?.status) {
          dispatch({ type: actionTypes.PACKAGE_UPDATE_SUCCESS });
          afterSuccess();
        } else {
          dispatch({
            type: actionTypes.PACKAGE_UPDATE_FALED,
          });
          message.error(res?.message, 10);
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.PACKAGE_UPDATE_FALED,
        });
      });
  };
};

export const getPackageById = (values) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.IS_PACKAGE_BY_ID_LOADING });
    Post("/agents/user/admin/get-package-by-id", values)
      .then((res) => {
        if (res?.status) {
          dispatch({
            type: actionTypes.PACKAGE_BY_ID_SUCCESS,
            payload: res?.data,
          });
        } else {
          dispatch({ type: actionTypes.PACKAGE_BY_ID_FALED });
        }
      })
      .catch((err) => {
        dispatch({ type: actionTypes.PACKAGE_BY_ID_FALED });
      });
  };
};
